import {Component, effect, input, model, signal} from '@angular/core';
import {IntraAnnualMetricsDto} from "../../../../pages/validate/service/validation-run-config-dto";
import { SharedPrimeNgModule } from 'src/app/shared.primeNg.module';

@Component({
    standalone:true,
    selector: 'qa-intra-annual-metrics',
    imports: [SharedPrimeNgModule],
    templateUrl: './intra-annual-metrics.component.html',
    styleUrl: './intra-annual-metrics.component.scss'
})
export class IntraAnnualMetricsComponent {
  disabled = input<boolean>(false);

  intraAnnualMetricTypes: string[] = ['Seasonal', 'Monthly'];

  defaultOverlaps: number[] = [0, 0];
  maxOverlaps: number[] = [45, 15];


  defaultIntraAnnualOverlap = signal(0);
  maxIntraAnnualOverlap = signal(45);
  selectedMetric = model<IntraAnnualMetricsDto | null>(null)

  constructor() {
    effect(() => {
      if (this.disabled() && this.selectedMetric()?.intra_annual_metrics) {
        this.toggleMetricSelection(false);
      }
    });
  }

  updateType(value: string) {
    this.selectedMetric.update((metric) => {
      metric.intra_annual_type = value;

      const ind = this.intraAnnualMetricTypes.indexOf(value);
      this.defaultIntraAnnualOverlap.set(this.defaultOverlaps[ind]);
      this.maxIntraAnnualOverlap.set(this.maxOverlaps[ind]);

      this.setOverlap(this.defaultOverlaps[ind]);

      return metric;
    });
  }

  setOverlap(value: number) {
    this.selectedMetric.update((metric) => {
      metric.intra_annual_overlap = value;
      return metric;
    });
  }

  toggleMetricSelection(value: boolean) {
    this.selectedMetric.update((metric) => {
      metric.intra_annual_metrics = value;


      if (value) {
        metric.intra_annual_type = this.intraAnnualMetricTypes[0];
        metric.intra_annual_overlap = this.defaultIntraAnnualOverlap();
      } else {
        metric.intra_annual_overlap = null;
        metric.intra_annual_type = null;
      }

      return metric;
    });
  }


}
